/**
 * ./reducers/index.js
 */

import {
  POPULATE_MESSAGES_SUCCESS,
  POPULATE_MESSAGES_PENDING,
  GET_LEGENDS_SUCCESS,
  GET_LEGENDS_PENDING,
  GET_LEGENDS_FAILED,
  GET_FILTER_PENDING,
  GET_FILTER_SUCCESS,
  GET_TABLE_SUCCESS,
  GET_TABLE_PENDING,
  GET_WORDSEARCH_SIMPLE_SUCCESS,
  GET_WORDSEARCH_SIMPLE_PENDING,
  GET_WORDSEARCH_SIMPLE_FAILED,
  GET_WORDSEARCH_MULTIPLE_SUCCESS,
  GET_WORDSEARCH_MULTIPLE_PENDING,
  GET_WORDSEARCH_MULTIPLE_FAILED,
  SHOW_ONLY_ACTIVE_TABLES,
  SHOW_ONLY_ACTIVE_ENT,
  WORDSEARCH_RESET,
  SEARCH_TERM,
  UPDATE_CHOOSEN_ELEMENTS,
  ITEM_HINT_DATA_PENDING,
  ITEM_HINT_DATA_SUCCESS,
  ITEM_HINT_DATA_FAILED,
  HIDE_TOOLTIP
} from '../actions';

const initialState = {
  messages: [],
  loading: false,
  legend: '',
  tables: {},
  wordsearchdatamultiple: {},
  wordsearchdatamultipleLoading: false,
  wordsearchdatasimple: {},
  wordsearchsimpleLoading: false,
  wsReset: false,
  itemhintdata: '',
  tooltip: false,
  searchTerm: "",
  choosenElements: [],
  showOnlyActTables: true,
  showOnlyActEnt: {collections: true, tables: true, writers: true, stylus: true, series:true,
                  subseries: true, sets: true, seals: true, chronologies: true, findareas:true, findplaces:true,
                  proveniences: true, years: true, locations: true, invnos: true}
}

export default function rootReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_ONLY_ACTIVE_ENT:
    //console.log(state.showOnlyActEnt)
    //var ny = {...state.showOnlyActEnt, [action.entity]: !state.showOnlyActEnt[action.entity]}
    //console.log(ny)
      return{
        ...state,
        showOnlyActEnt: {...state.showOnlyActEnt, [action.entity]: !state.showOnlyActEnt[action.entity]}
      }
      case SEARCH_TERM:
        return {
          ...state,
          searchTerm: action.searchTerm
        };
    case SHOW_ONLY_ACTIVE_TABLES:
      return{
          ...state,
          showOnlyActTables: !state.showOnlyActTables
      };
      case WORDSEARCH_RESET:
      return{
        ...state,
          wsReset: !state.wsReset,
          wordsearchdatasimple: {},
          wordsearchdatamultiple: {}
      }

      case UPDATE_CHOOSEN_ELEMENTS:
      const tempArray = state.choosenElements;
        if (tempArray.indexOf(action.eventChecked) > -1) {
            tempArray.splice(tempArray.indexOf(action.eventChecked), 1);
        } else {
          tempArray.push(action.eventChecked)
        }
      return {
        ...state,
        choosenElements: tempArray
      }

      case HIDE_TOOLTIP:
      return{
        ...state,
        tooltip: false
      }
      case ITEM_HINT_DATA_PENDING:
      return{
        ...state,
        itemhintdata: '',
        tooltip: false
      }
      case ITEM_HINT_DATA_SUCCESS:
    //  console.log(action.data)
      return{
        ...state,
        itemhintdata: action.data.content,
        tooltip: true
      }
      case ITEM_HINT_DATA_FAILED:
      return{
        ...state,
        itemhintdata: '',
        tooltip: false
      }

      case GET_LEGENDS_PENDING:
      return{
        ...state,
        legend: ''
      }
      case GET_LEGENDS_SUCCESS:
    //  console.log(action.data)
      return{
        ...state,
        legend: action.data.legends.locations
      }
      case GET_LEGENDS_FAILED:
      return{
        ...state,
        legend: 'error'
      }

      case POPULATE_MESSAGES_PENDING:
      return{
        ...state,
        loading: true
      }
      case GET_FILTER_PENDING:
      return{
        ...state,
        loading: true

      }
    case POPULATE_MESSAGES_SUCCESS:

      return {
        ...state,
        messages: action.messages,
        loading: false
      };
//  .then((messages) => dispatch(getFilterSuccess(messages,eventChecked, entValue, checked, id)))
//eventcheck om det er tables, collection osv
//entValue , "t__"+table.id
      case GET_FILTER_SUCCESS:



            const messagesTemp = {}

          Object.keys(state.messages).map(function(entity){
                messagesTemp[entity] = state.messages[entity].map(function(ent){
                  const id = ent.id ? ent.id : ent.value

                    if (action.messages.hasOwnProperty(entity) && action.messages[entity][id] !== undefined){


                      return {...ent, count: action.messages[entity][id], active: true, checked: ((action.entity === entity && id===action.id)?action.eventValue:ent.checked)}
                      } else {
                        if (action.entity === entity && entity !=="tables"){
                          return {...ent,  checked: ((action.entity === entity && id===action.id)?action.eventValue:ent.checked)}

                        } else {
                          return {...ent, count: 0, active: false, checked: ((action.entity === entity && id===action.id)?action.eventValue:ent.checked)}

                        }

                          }
                    })
                //    }
                return messagesTemp;
                  })




        return {
          ...state,
        messages: messagesTemp,
        loading: false
      };

  case GET_TABLE_PENDING:
    return {
      ...state,
      loading: true
    }
      case GET_TABLE_SUCCESS:
        return {
          ...state,
          tables: action.table,
          loading: false
        };
        case GET_WORDSEARCH_SIMPLE_PENDING:
          return {
            ...state,
            wordsearchdatasimple: {},
            wordsearchsimpleLoading: true
          };
          case GET_WORDSEARCH_SIMPLE_FAILED:
          return {
            ...state,
            wordsearchdatasimple: {inittext: action.error},
            wordsearchsimpleLoading: false
          };
      case GET_WORDSEARCH_SIMPLE_SUCCESS:
        return {
          ...state,
          wordsearchdatasimple: action.data,
          wordsearchsimpleLoading: false
        };

        case GET_WORDSEARCH_MULTIPLE_PENDING:
          return {
            ...state,
            wordsearchdatamultiple: {},
            wordsearchmultipleLoading: true
          };
          case GET_WORDSEARCH_MULTIPLE_FAILED:
          return {
            ...state,
            wordsearchdatamultiple: {inittext: action.error},
            wordsearchmultipleLoading: false
          };
      case GET_WORDSEARCH_MULTIPLE_SUCCESS:
        return {
          ...state,
          wordsearchdatamultiple: action.data,
          wordsearchmultipleLoading: false
        };
    default:
      return state;
  }


}


/*
return {
  ...state,
  todos: [
    { text: action.text },
    ...state.todos
  ]
};

case REMOVE_TODO:
return {
  ...state,
  todos: [
    ...state.todos.slice(0, action.index),
    ...state.todos.slice(action.index + 1)
  ]
};
*/



// WEBPACK FOOTER //
// ./src/reducers/index.js